import apiUtils from '@utils/apiUtils';
import { apiConstants } from '../utils/constants';
import { fetchAPI } from './apiServiceHelper';

const defaultGetParam = apiUtils.getDefaultGetParams();

let api = {
    locations: {
        countries: {
            getWithHotels: ({ offset = defaultGetParam.offset, limit = defaultGetParam.limit }) => {
                return fetchAPI.getList(`${apiConstants.BASE_URL}/api/locations`, {
                    withEntity: 'HOTEL',
                    returnTypeEntity: 'COUNTRY',
                    limit,
                    offset,
                });
            },
        },
        states: {
            getWithHotels: ({
                filter = {},
                offset = defaultGetParam.offset,
                limit = defaultGetParam.limit,
            }) => {
                const filterApi = {
                    countryCodes: filter.countryCodes ? filter.countryCodes.join(',') : undefined,
                };

                return fetchAPI.getList(`${apiConstants.BASE_URL}/api/locations`, {
                    withEntity: 'HOTEL',
                    returnTypeEntity: 'STATE',
                    ...filterApi,
                    limit,
                    offset,
                });
            },
        },
        cities: {
            getWithHotels: ({
                filter = {},
                offset = defaultGetParam.offset,
                limit = defaultGetParam.limit,
            }) => {
                const filterApi = {
                    countryCodes: filter.countryCodes ? filter.countryCodes.join(',') : undefined,
                    stateCodes: filter.stateCodes ? filter.stateCodes.join(',') : undefined,
                    keyword: filter.name || undefined,
                };

                return fetchAPI.getList(`${apiConstants.BASE_URL}/api/locations`, {
                    withEntity: 'HOTEL',
                    returnTypeEntity: 'CITY',
                    ...filterApi,
                    limit,
                    offset,
                });
            },
        },
    },
};

export default api;
